import { calculateAutoTopupCardFee, calculateTopUpBreakdown, type TopUpBreakdown } from '../hooks/useAutoTopUp'

/**
 * #1800 ポイント精算 API に渡す「不足分チャージ」のパラメータ。
 *
 * 残高が足りていれば undefined (残高だけで払う)。足りなければ不足分と手数料を
 * 返し、呼び元は AutoTopUpSheet で客の承認を取ってから API に渡す (#1190 の
 * QR 決済と同じ 1 tap 導線)。手数料の計算は hooks/useAutoTopUp と同じ式。
 */
export function topupParamsFor(balance: number, billAmount: number): { topupAmount: number; topupFeeJpyc: number } | undefined {
  const shortfall = Math.max(0, billAmount - balance)
  if (shortfall <= 0) return undefined
  return { topupAmount: shortfall, topupFeeJpyc: calculateAutoTopupCardFee(shortfall) }
}

export function topupBreakdownFor(balance: number, billAmount: number): TopUpBreakdown {
  return calculateTopUpBreakdown(balance, billAmount)
}
